import { render, staticRenderFns } from "./category-list.vue?vue&type=template&id=41b80998&scoped=true&"
import script from "./category-list.vue?vue&type=script&lang=js&"
export * from "./category-list.vue?vue&type=script&lang=js&"
import style0 from "./category-list.vue?vue&type=style&index=0&id=41b80998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b80998",
  null
  
)

export default component.exports